import {
  deleteElement,
  fetchElements,
  saveElementsType,
  updateElement,
} from "@/lib/utils";
import { GroupLayer } from "@/types/models/capas";
import type { GruposCapasRepository } from "@/lib/repositories/interfaces/grupos-repository.interface";

const GRUPOS_CAPAS_FIELDS = ["*", "translations.*"] as const;

export const gruposCapasRepository: GruposCapasRepository = {
  fetchByTenant: (tenantId: number): Promise<GroupLayer[]> =>
    fetchElements<GroupLayer>(
      "grupos_capas",
      [...GRUPOS_CAPAS_FIELDS],
      undefined,
      {
        tenant: { _eq: tenantId },
      }
    ),
    
  create: async (payload: Partial<GroupLayer>): Promise<GroupLayer> =>
    (await saveElementsType<GroupLayer>("grupos_capas", [payload]))[0],

  update: (id: number, changes: Partial<GroupLayer>) =>
    updateElement("grupos_capas", id, changes),

  delete: (id: number): Promise<void> =>
    deleteElement("grupos_capas", id),
};
